"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _lib = require("../../lib");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Arc404 = function Arc404(_ref) {
  var status = _ref.status,
    title = _ref.title,
    subTitle = _ref.subTitle,
    extra = _ref.extra,
    icon = _ref.icon,
    width = _ref.width,
    height = _ref.height;
  return /*#__PURE__*/_react["default"].createElement(_lib.Result, {
    icon: icon && /*#__PURE__*/_react["default"].createElement("img", {
      src: icon,
      width: width ? width : "300",
      height: height ? height : "361"
    }),
    status: status,
    title: title,
    subTitle: subTitle,
    extra: extra
  });
};
var _default = Arc404;
exports["default"] = _default;